import { ActionStatus } from '../../../common/constants/action-status';
import { FreeTrialState } from '../interfaces/free-trial-states.interface';
import { cancelFreeTrial } from '../thunks/free-trial-cancel.thunk';
import { createSlice } from '@reduxjs/toolkit';
import { defaultApiState } from '../../../common/constants/api-constants';
import { getFreeTrialAvailability } from '../thunks/check-free-trial-availability.thunk';
import { getFreeTrialAvailabilityGuest } from '../thunks/check-free-trial-availability-guest.thunk';

/*----- CREATE INITIAL STATE ------*/

export const freeTrialStateInitialState: FreeTrialState = {
  freeTrialAvailability: defaultApiState,
  freeTrialCancel: defaultApiState,
  freeTrialConversion: {
    convertedIsbns: [],
  },
  freeTrialTerms: {
    accepted: false,
  },
};

/*----- CREATE STORE SLICE ------*/

export const freeTrialSlice = createSlice({
  name: 'freeTrial',
  initialState: freeTrialStateInitialState,
  reducers: {
    clearFreeTrialConvertedIsbns: (state) => {
      state.freeTrialConversion.convertedIsbns = [];
    },
    setFreeTrialConvertedIsbns: (state, action) => {
      state.freeTrialConversion.convertedIsbns = action.payload;
    },
    updateFreeTrialConvertedIsbns: (state, action) => {
      state.freeTrialConversion.convertedIsbns.push(action.payload);
    },
    setFreeTrialTermsAccepted: (state, action) => {
      state.freeTrialTerms.accepted = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getFreeTrialAvailability.pending, (state) => {
        state.freeTrialAvailability.status = ActionStatus.loading;
      })
      .addCase(getFreeTrialAvailability.fulfilled, (state, action) => {
        state.freeTrialAvailability.status = ActionStatus.succeeded;
        state.freeTrialAvailability.data = action.payload;
      })
      .addCase(getFreeTrialAvailability.rejected, (state, action) => {
        state.freeTrialAvailability.status = ActionStatus.failed;
        state.freeTrialAvailability.error = action.error.message || '';
      })
      .addCase(getFreeTrialAvailabilityGuest.pending, (state) => {
        state.freeTrialAvailability.status = ActionStatus.loading;
      })
      .addCase(getFreeTrialAvailabilityGuest.fulfilled, (state, action) => {
        state.freeTrialAvailability.status = ActionStatus.succeeded;
        state.freeTrialAvailability.data = action.payload;
      })
      .addCase(getFreeTrialAvailabilityGuest.rejected, (state, action) => {
        state.freeTrialAvailability.status = ActionStatus.failed;
        state.freeTrialAvailability.error = action.error.message || '';
      })
      .addCase(cancelFreeTrial.pending, (state) => {
        state.freeTrialCancel.status = ActionStatus.loading;
      })
      .addCase(cancelFreeTrial.fulfilled, (state, action) => {
        state.freeTrialCancel.status = ActionStatus.succeeded;
        state.freeTrialCancel.data = action.payload;
      })
      .addCase(cancelFreeTrial.rejected, (state, action) => {
        state.freeTrialCancel.status = ActionStatus.failed;
        state.freeTrialCancel.error = action.error.message || '';
      });
  },
});

/*----- CREATE SLICE ACTIONS ------*/

export const {
  clearFreeTrialConvertedIsbns,
  setFreeTrialConvertedIsbns,
  setFreeTrialTermsAccepted,
  updateFreeTrialConvertedIsbns,
} = freeTrialSlice.actions;

/*----- CREATE REDUCER ------*/

export const freeTrialReducer = freeTrialSlice.reducer;
